<template>
  <div style="height: 100%">
    <div id="cardQ">
      <div id="question">
        {{ french }}
      </div>

      <spelling-answer
          :answer="english"
          :pass="pass"
          :sameLanguage="sameLanguage"
          :answerTrad="answerTrad"
          @goodAnswer="giveAnswer">
      </spelling-answer>


      <div class="bigRoundAngles flexwrap centercenter clickable red" style="padding: 2vw; justify-items: flex-end"
           @click="giveAnswer(false); pass = true" v-if="isMobile">
        <span>Passer</span> <i class="fas fa-arrow-right" style="margin-left: 2vw"></i>
      </div>
    </div>

  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "vocabularySpelling",

  created() {
    if(this.answerLanguage === 'fr') {
      this.goodAnswer = this.french;
      this.answerTrad = this.english;
      this.sameLanguage = true;
    }
    else {
      this.goodAnswer = this.english;
      this.answerTrad = this.french;
    }
  },

  components: {
    spellingAnswer: () => import(/* webpackPrefetch: true */ '@/components/spellingAnswer.vue')
  },

  props: {
    english: String,
    french: String,
    answerLanguage: String
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    pass: {
      get() {
        return this.passNext
      },
      set(value) {
        this.passNext = value
      }
    }
  },

  methods: {

    giveAnswer(isCorrect) {
      let timeout = 800;
      if(!isCorrect) {
        timeout = 2000;
      }
      window.setTimeout(() => (this.$emit('answer', isCorrect)), timeout)
    },
  },

  data() {
    return {
      passNext: false,
      sameLanguage: false,
      answerTrad: '',
    }
  }


}
</script>

<style scoped>
#cardQ {
  position: relative;
  display: grid;
  grid-template-rows: auto 1fr auto;
  justify-content: center;
  justify-items: center;
  align-items: center;
  width: 100%;
  height: calc(100% - 5vw);
  padding: 2.5vw;
  background-color: var(--color2);
}

#question {
  align-self: flex-end;
  font-size: 300%;
  font-weight: bold;
  text-align: center;
}

@media screen and (max-device-width: 767px) {
  #cardQ {
    height: calc(100% - 15vw);
    grid-template-rows: auto 1fr 15vw;
  }

}
</style>